import { Box, Typography } from '@mui/material';

const SqlQueryBlock = ({ query }: { query: string }) => {
  if (!query)
    return (
      <Typography variant="caption" color="error">
        No SQL query found for this rule.
      </Typography>
    );

  const displaySql = query
    .replace(/billing_stg\.invoice_claims_client_split/gi, '{{TABLE}}')
    .replace(/sims\.active_member_summary_v1/gi, '{{TABLE}}')
    .replace(/sims\.gp_sales_order_details_v1/gi, '{{TABLE}}')
    .replace(/\s+/g, ' ')
    .trim();

  return (
    <Box
      sx={{
        p: 2,
        bgcolor: '#fcfcfc',
        borderRadius: '4px',
        border: '1px solid #e0e0e0',
        maxHeight: '250px',
        overflow: 'auto',
      }}
    >
      <Typography
        variant="caption"
        component="pre"
        sx={{
          fontFamily: "'Roboto Mono', monospace",
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all',
          color: '#444',
          fontSize: '0.85rem',
          lineHeight: 1.5,
        }}
      >
        {displaySql}
      </Typography>
    </Box>
  );
};

export default SqlQueryBlock;
